/**
 * Resolve match winner from a WS message and/or merged client game state.
 *
 * Uses ONLY the server-authoritative winner: mergedGameState.winner, msg.gameState.winner,
 * or msg.gameStateMeta.winner (attack-complete-minimal carries it in gameStateMeta).
 *
 * It intentionally does NOT infer a winner from general health. The server always sets the
 * winner when a game actually ends (battleEngine.checkWinner via resolveWinnerWithoutOverwriting)
 * before it broadcasts attack-complete. Inferring client-side from an intermediate state — e.g.
 * attack-initiated applied lethal damage (a general at 0 HP) before the authoritative
 * attack-complete set `winner` — made the game-end useEffect fire early: the inferred winner let
 * the navigation gate pass, but didHumanPlayerWinGame reads the still-null explicit `winner`, so a
 * real win was navigated as a loss (and the isTransitioningRef guard then swallowed the real win).
 */
export function resolveBattleWinnerFromWsMessage(msg, mergedGameState) {
  if (!msg || typeof msg !== 'object') {
    throw new Error('resolveBattleWinnerFromWsMessage: msg is required');
  }
  if (mergedGameState?.winner != null && mergedGameState.winner !== undefined) {
    return mergedGameState.winner;
  }
  if (msg.gameState?.winner != null && msg.gameState.winner !== undefined) {
    return msg.gameState.winner;
  }
  if (msg.gameStateMeta?.winner != null && msg.gameStateMeta.winner !== undefined) {
    return msg.gameStateMeta.winner;
  }
  return null;
}
